define('views/components/product_info/schema_list',['require','backbone','views/components/product_info/info','text!templates/components/product_info/schema_list.html'],function (require) {
  var Backbone = require("backbone");

  var ChildView = require('views/components/product_info/info');

  var temp = require("text!templates/components/product_info/schema_list.html");


  return Backbone.Marionette.CompositeView.extend({
    childViewContainer: "#info-container",
    childView: ChildView,
    className: "product-info",
    template: _.template(temp),



    initialize: function () {
        this.listenTo(this.collection, 'fetch_complete', this._onFetch);

        this.collection.fetch();
    },

    ui: function () {
      return {
        addButton: "#info-add-button",
      };
    },

    events: {
        "click @ui.addButton": "addButtonClicked",
    },

    addButtonClicked: function(){
  
      var filters = this.collection.getFilter();
      
      var SchemaModel = this.collection.model;

      var new_info_schema = new SchemaModel({
        product: filters.product
      });

      this.collection.push(new_info_schema);
    },


    _onFetch: function () {
        this.render();
    }


  });
});

